import { HttpParams } from '@angular/common/http';

export class UtilitiesService {

    constructor() {

    }
    public getHttpParams<T>(obj: T): HttpParams {
        let params = new HttpParams();
        Object.keys(obj).forEach(key => {
            if (obj[key] !== undefined && obj[key] !== null) {
                params = params.append(key, obj[key]);
            }
        });;
        console.log(params);
        return params;
    }
    public getQueryString<T>(obj: T) {
        console.log("obj:", obj);
        let string = Object.keys(obj).map((key) => {
            if (obj[key] !== undefined && obj[key] !== null) {
                return encodeURIComponent(key) + '=' + encodeURIComponent(obj[key])
            }
            return;
        }).join('&');
        console.log("string:", string);
        return string;
    }
}
